import { DialogueUIOptionConfig } from "../../components/ui/YouRespondUI";
import { NurseStationComputerUIConfig } from "../../components/ui/NurseStationComputerUI";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { Segments } from "../../cvp-webgames-core/Scenario/Segments";
import { constants } from "../../misc/constants";
import { CalmBaseScenario, ScoreType, Window508Type } from "../CalmBaseScenario";
import Scenario2 from "./Scenario2";
import { IonItemOptions } from "@ionic/react";
import { alertController } from "@ionic/core";

export default class Scenario2Part3 extends BaseScenarioPart<CalmBaseScenario> {

	private partIndx = 0;

	chapterIds = {
		scenario2_1a_s3: 'CALM - Scenario 2 - 1A - Segment 3', //a.	Marco and CN check the policy on the computer - to Computer UI / Quiz
		scenario2_1a_s4: 'CALM - Scenario 2 - 1A - Segment 4', //a.	Marco & CN leave computer, Marco asks what else he should do - to Respond UI
		scenario2_1b_s8: 'CALM - Scenario 2 - 1B - Segment 8', //a.	CN orders terminal room clean, Marco asks what to do next - to Respond UI
		scenario2_1b_s9: 'CALM - Scenario 2 - 1B - Segment 9', //a.	CN orders terminal room clean - to segment of going to pc
		scenario2_1b_s10: 'CALM - Scenario 2 - 1B - Segment 10', //a.	CN notifies the Nurse Manager, Marco asks what to do next - to respond UI
		scenario2_1b_s11: 'CALM - Scenario 2 - 1B - Segment 11', //a.	CN notifies the Nurse Manager  - to segment of going to pc
		scenario2_1b_s12: 'CALM - Scenario 2 - 2B - Segment 12', //a.	CN goes to PC to enter report - to Computer Report UI
	}

	endMarcoResponse: DialogueUIOptionConfig[] = [];

	constructor(scenario: Scenario2, private onDone: () => void) {
		super(scenario);
		CalmBaseScenario.partIndx = this.partIndx;
	}

	lastResponseVid: string = null;

	isWeirdQuestionDone = false;

	public get partId(): string {
		return constants.scenarios.scenario2.parts.level2Part3.id;
	}

	public get videoUrl(): string[] {
		return ['./assets/videos/scenario2/calm-scenario2-avatar' + this.scenario.avatarIndx + '.mp4'];
	}

	public start() {
		const context = this;
		context.segment1Step2MarcoDialogue();
	}

	private segment1Step2MarcoDialogue() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		var policyReply = "I’ll look up our facility’s policies on airborne precaution patients, just to be sure we follow all the proper procedures.";
		var roomCleanReply = "I’ll order a terminal room clean.";
		var nurseManagerReply = "I’ll notify the Nurse Supervisor.";
		var isFirst = false

		if (this.isWeirdQuestionDone) {
			context.segment5Step1GoToNurseStation();
			return;
		}
		if (context.endMarcoResponse.length === 0) {
			isFirst = true;
			var scen2 = (context.scenario as Scenario2);
			if (!scen2.policyResponse) {
				context.endMarcoResponse.push({
					text: policyReply, // this one is the optional one					
					scoreType: ScoreType.Ok,
					isCorrect: true, // Answer Rank is Okay					
				});
			}
			context.endMarcoResponse.push({
				text: roomCleanReply,
				scoreType: ScoreType.Ok,
				isCorrect: true // Answer Rank is Okay
			});
			context.endMarcoResponse.push({
				text: nurseManagerReply,
				scoreType: ScoreType.Ok,
				isCorrect: true // Answer Rank is Okay
			});


		}
		var onOptionSelected = (selectedOption: DialogueUIOptionConfig) => {
			context.scenario.destroyAllUIInstances();
			for (var index = 0; index < context.endMarcoResponse.length; index++) {
				if (selectedOption.text === context.endMarcoResponse[index].text) {
					context.endMarcoResponse[index].hide = true;
					break;
				}
			}
			context.isWeirdQuestionDone = context.endMarcoResponse.filter(e => !e.hide).length === 0;

			// if (isDone) {
			// 	context.segment5Step1GoToNurseStation(); 
			// }
			if (selectedOption.text.indexOf(policyReply) !== -1) {
				context.scenario.evaluateAnswer(selectedOption, () => { }, context.partIndx);
				//context.playVideoChapter(this.chapterIds.scenario2_1a_s3, () => { // We need to know whether we need the last response from Marco or not. If this is not the last response, then the segmentId is saved and then called to play at this point.
					context.segment4aStep1PolicyReplyDepart();
				//})
			}
			else if (selectedOption.text.indexOf(roomCleanReply) !== -1) {
				context.scenario.evaluateAnswer(selectedOption, () => { }, context.partIndx);
				//context.playVideoChapter(this.chapterIds.scenario2_1b_s8, () => { // See above
					context.segment3aStep1RoomCleanReplyStart();
				//})
			}
			else if (selectedOption.text.indexOf(nurseManagerReply) !== -1) {
				context.scenario.evaluateAnswer(selectedOption, () => { }, context.partIndx);
				//context.playVideoChapter(this.chapterIds.scenario2_1b_s10, () => { // See above
					context.segment2aStep1NurseManagerReplyStart();
				//})
			}
		};
		if (isFirst) {
			this.scenario.dialog(
				'CN-C09-L2-040b',
				context.endMarcoResponse,
				onOptionSelected
			);
			context.scenario.updateObjective('Select your Response to Marco');
		}
		else {
			//context.playVideoChapter(this.lastResponseVid, () =>
				context.scenario.updateObjective('Select your Response to Marco'
				//)
				);
			context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.YouRespondUI, {
				onOptionSelected: onOptionSelected,
				options: this.endMarcoResponse
			})
		}
	}

	private segment4aStep1PolicyReplyDepart() {
		var context = this;
		context.scenario.updateObjective('Check the Policies with Marco');
		context.playVideoChapter(this.chapterIds.scenario2_1a_s3, () => {  //a.	Marco and CN check the policy on the computer - to Computer UI / Quiz
			context.scenario.updateObjective('');
			// context.showNurseStationComputer();
//		});
		context.scenario.update508Window(Window508Type.NurseStationComputerUI);

		const instanceId = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.NurseStationComputerUI, {
			reports: null,
			review: {
				text:
					`
				<p class="regular-description-font" style="margin: 0">
					<span style="color: rgb(222, 225, 156)">INITIAL MANAGEMENT OF PATIENTS WITH S/KI TB</span> They have the experience to understand the delicacy 
					and urgency of a given situation and should be able to guide staff accordingly. <br /><br />
	
						<span style="color: rgb(222, 225, 156)">(1) Airborne precautions will be initiated promptly when a patient presents with symptoms of TB.</span> <br /><br />
	
							(a) The patient will be given a surgical-grade mask and will be instructed not to remove it.
	
	
							(b) The patient will be placed in an isolation booth or negative airflow room as soon as possible. The patient may remove his/her mask while in the isolation booth or negative airflow room. If no isolation room/booth is available, the patient will remain masked.  
						
						
							(c) A sign representing Airborne/Respiratory Isolation will be displayed outside the doorway to indicate isolation precautions are in effect. 
						
							<span style="color: rgb(222, 225, 156)">(2) If a patient with S/KI TB must be transported outside the TB room/booth, the patient must wear a surgical mask. Staff transporting the patient do not need to wear respiratory protection outside the isolation room/booth during transportation.</span> <br /><br />
	
							<span style="color: rgb(222, 225, 156)">(3) Staff must wear NIOSH approved respiratory protection (N95 or better) at all times within the negative pressure isolation room/booth.</span> <br /><br />
	
							<span style="color: rgb(222, 225, 156)">(4) Cough-inducing procedures such as sputum induction of acid-fast bacillus (AFB), or bronchoscopy or endotracheal intubation must be performed in a negative pressure isolation room/booth. Staff collecting these specimens must wear NIOSH approved respiratory protection (N95 or better) during the procedure.</span> <br /><br />
				</p>
				`
			},
			reflects: null,
			onClosed: (config: NurseStationComputerUIConfig) => {
				context.scenario.update508Window(Window508Type.Main);
				context.scenario.gameManager.UiManager.destroyUIInstanceById(instanceId);
				context.segment4aStep2NurseStationPolicy();
			}
		})
	});
	}

	private segment4aStep2NurseStationPolicy() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('');
		context.scenario.update508Window(Window508Type.NurseStationComputerSingleQuestionUI);
		context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.NurseStationComputerSingleQuestionUI, {
			title: 'While inside the negative pressure room with an S/KI TB patient, who needs to wear a face mask according to this unit’s policy?',
			options: [
				{
					text: 'Only the staff needs an N95 mask or PAPR.',
					isCorrect: true,
					feedback: 'Staff need to wear an N95 or PAPR whenever in the negative pressure room. The patient does not need to wear any mask.'
				},
				{
					text: 'Both staff and patient need a surgical mask.',
					isCorrect: false,
					feedback: 'Only one of these individuals, not both staff and patient, are required to wear a mask when inside the negative pressure room. '
				},
				{
					text: 'Only the patient needs a surgical mask.',
					isCorrect: false,
					feedback: 'For this unit’s policy, the patient is not required to wear a surgical mask while inside the negative pressure room.'
				}
			],
			onChoiceSelected: (selectedOption: DialogueUIOptionConfig) => {
				context.scenario.evaluateAnswer(selectedOption, () => { }, context.partIndx)
			},
			onClosed: () => {
				context.segment4bStep1PolicyReplyReturn();
			},
		});
	}

	private segment4bStep1PolicyReplyReturn() {
		var context = this;		
		this.scenario.destroyAllUIInstances();		
		if (this.isWeirdQuestionDone) {
			context.showNurseStationComputer(); // if last step is checking policy there is no follow up with Marco, we're already at computer so just show it
			return;
		}
		else {
			this.scenario.destroyAllUIInstances();			
			context.scenario.updateObjective('');
			this.lastResponseVid = this.chapterIds.scenario2_1a_s4; //a.	Marco & CN leave computer, Marco asks what else he should do - to Respond UI
			context.playVideoChapter(this.chapterIds.scenario2_1a_s4, () => { //a.	CN orders terminal room clean, Marco asks what to do next - to Respond UI
				context.segment1Step2MarcoDialogue();
			})
		}
	}

	private segment2aStep1NurseManagerReplyStart() {
		var context = this;		
		if (this.isWeirdQuestionDone) {
			context.scenario.updateObjective('Inform the Nurse Manager');
			context.playVideoChapter(this.chapterIds.scenario2_1b_s11, () => {		 //a.	CN notifies the Nurse Manager  - to segment of going to pc	
				context.segment5Step1GoToNurseStation();
				context.scenario.updateObjective('');
				return;
			})
		}
		else {
			this.scenario.destroyAllUIInstances();			
			context.scenario.updateObjective('Inform the Nurse Manager');
			context.playVideoChapter(this.chapterIds.scenario2_1b_s10, () => { //a.	CN notifies the Nurse Manager, Marco asks what to do next - to respond UI
				context.segment2bStep1NurseManagerReplyReturn();
			})
		}
	}

	private segment2bStep1NurseManagerReplyReturn() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('');
		context.segment1Step2MarcoDialogue();
	}

	private segment3aStep1RoomCleanReplyStart() {
		var context = this;		
		if (this.isWeirdQuestionDone) {
			context.scenario.updateObjective('Order the Terminal Room Clean');
			context.playVideoChapter(this.chapterIds.scenario2_1b_s9, () => {		 //a.	CN orders terminal room clean - to segment of going to pc
				context.segment5Step1GoToNurseStation();
				context.scenario.updateObjective('');
				return;
			})
		}
		else {
			this.scenario.destroyAllUIInstances();
			context.scenario.updateObjective('Order the Terminal Room Cleaning');
			context.playVideoChapter(this.chapterIds.scenario2_1b_s8, () => { //a.	CN orders terminal room clean, Marco asks what to do next - to Respond UI
				context.segment3bStep1RoomCleanReplyReturn();
			})
		}
	}

	private segment3bStep1RoomCleanReplyReturn() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('');
		context.segment1Step2MarcoDialogue();

	}

	private segment5Step1GoToNurseStation() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('Going to Nurse\'s Station Computer');
		context.playVideoChapter(this.chapterIds.scenario2_1b_s12, () => {  //a.	CN goes to PC to enter report - to Computer Report UI
			context.scenario.updateObjective('');
			context.showNurseStationComputer();
		});
	}

	private showNurseStationComputer() {
		var context = this;
		context.scenario.updateObjective('');
		context.scenario.update508Window(Window508Type.NurseStationComputerUI);

		context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.NurseStationComputerUI, {
			reports: [
				{
					title: 'Incident',
					description: 'This was added to the report: An in-patient was identified as possible TB. Patient moved immediately to negative pressure room. Airborne precautions according to policy invoked. '
				},
				{
					title: '24 Hour',
					description: 'This was added to the report: An in-patient was identified as possible TB. Patient moved immediately to negative pressure room. Airborne precautions according to policy invoked. Nurse Supervisor notified immediately of patient condition.'
				},
				{
					title: 'End of Shift',
					description: 'This was added to the report: An in-patient was identified as possible TB. Patient moved immediately to negative pressure room. Airborne precautions according to policy invoked. Nurse Supervisor notified immediately of patient condition. '
				}
			],
			review: {
				text:
					`
				<p class="regular-description-font" style="margin: 0;">
				Handling a transmission-based precaution patient can be a turbulent, stressful time for nursing staff. <br /><br />

				In addition to ensuring that the patient is well-cared for, nurses and other hospital staff must make sure that they 
				<span style="color: rgb(222, 225, 156)">prevent contamination across the unit and themselves</span>. If a patient is placed on airborne or respiratory precaution, it 
				is your job as a Charge Nurse to <span style="color: rgb(222, 225, 156)">protect your unit</span>. The unit should be properly stocked with the proper <span style="color: rgb(222, 225, 156)">Personal 
				Protective Equipment (PPE)</span> at all times. <br /><br />
				Furthermore, the staff need to understand the unit policies on each type of precaution, know what PPE <span style="color: rgb(222, 225, 156)">equipment is 
				required for each type of precaution</span>, always follow <span style="color: rgb(222, 225, 156)">hand hygiene policy</span>, 
				and understand the proper <span style="color: rgb(222, 225, 156)">procedures for donning and doffing PPE</span>. <br /><br />
				In this scenario, the unit policy for possible tuberculosis required an N95 mask or PAPR for staff whenever 
				in the negative pressure room and while taking sputum samples but did not require protection while 
				transporting a patient. <br /><br />
				<span style="color: rgb(222, 225, 156)">Your unit policies may be different.</span>
				</p>
				`
			},
			reflects: [
				{
					title: 'What are your facility’s policies on transmission-based precaution patients? Contact precautions? Droplet precautions? Airborne precautions?',
					answer: ''
				},
				{
					title: 'What is your unit policy for PPE when transporting such a patient?',
					answer: ''
				},
				{
					title: 'How can you ensure that your staff is prepared to handle transmission-based precaution patients?',
					answer: ''
				},
				{
					title: 'Is your staff up to date on their mask fitting certification?',
					answer: ''
				},
				{
					title: 'What should you do if your unit’s negative pressure room is already filled with a patient? Is there other equipment that could be used when negative air pressure is not available?',
					answer: ''
				}
			],
			onClosed: (config: NurseStationComputerUIConfig) => {
				context.scenario.update508Window(Window508Type.Main);
				context.partEnd();
			}
		})
	}

	private partEnd() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		this.scenario.gameManager.customData.saveData.scenarios[this.scenario.currentLevel].badges[context.partIndx].points = CalmBaseScenario.scores[this.partIndx];

		this.scenario.gameManager.customData.saveData.scenarios[this.scenario.currentLevel].badges[context.partIndx].isUnlocked = true;
		this.scenario.gameManager.customData.saveData.scenarios[context.scenario.currentLevel].lastPartId = this.partId;

		this.scenario.gameManager.customData.saveGame(this.scenario.gameManager);

		this.scenario.showBadgingUI(context.partIndx, () => {
			context.onDone();
		});
	}
}